import { Routes } from '@angular/router';
import { canActivateAuthorization } from '../../security/authorization.guard';
import { PermissionResponse } from '../../core/base-api';
import { ConfigurationComponent } from './configuration.component';
import { LinkEditComponent } from './link/edit/link-edit.component';
import { ViewMode } from '../../ech0134/meldungsempfaenger/view-mode.enum';
import { GrundstueckConfigResolver } from './rubrik/grundstueck/grundstueck-config-resolver';
import { StandardrechtConfigResolver } from './rubrik/recht/standardrecht-config-resolver';
import { PfandrechtConfigResolver } from './rubrik/recht/pfandrecht-config-resolver';
import { ConfigFileManagerComponent } from './manage/config-file-manager.component';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { RubrikVMService } from './rubrik/rubrik-v-m.service';
import { RubrikConfigService } from './rubrik/rubrik-config.service';
import { TranslateLinkNamePipe } from './link/translateLinkName.pipe';
import { LinkResolver } from './link/edit/link-resolver';
import PermissionsEnum = PermissionResponse.PermissionsEnum;

export const ConfigurationRoutes: Routes = [
  {
    path: 'konfiguration',
    canActivate: [canActivateAuthorization],
    data: {
      permissions: [PermissionsEnum.CONFIGMANAGER]
    },
    loadChildren: () => routes,
    providers: [
      NgbTooltip,
      RubrikVMService,
      RubrikConfigService,
      TranslateLinkNamePipe,
      LinkResolver,
      GrundstueckConfigResolver,
      PfandrechtConfigResolver,
      StandardrechtConfigResolver
    ]
  }
];

const routes: Routes = [
  {
    path: '',
    canActivate: [canActivateAuthorization],
    component: ConfigurationComponent,
    data: {
      permissions: [PermissionsEnum.LOGIN, PermissionsEnum.CONFIGMANAGER]
    },
    resolve: {
      grundstueck: GrundstueckConfigResolver,
      standardrecht: StandardrechtConfigResolver,
      pfandrecht: PfandrechtConfigResolver
    }
  },
  {
    path: 'links/new',
    canActivate: [canActivateAuthorization],
    component: LinkEditComponent,
    data: {
      permissions: [PermissionsEnum.LOGIN, PermissionsEnum.CONFIGMANAGER],
      viewMode: ViewMode.NEW
    }
  },
  {
    path: 'links/:id',
    canActivate: [canActivateAuthorization],
    component: LinkEditComponent,
    data: {
      permissions: [PermissionsEnum.LOGIN, PermissionsEnum.CONFIGMANAGER],
      viewMode: ViewMode.EDIT
    }
  },
  {
    path: 'file',
    canActivate: [canActivateAuthorization],
    component: ConfigFileManagerComponent,
    data: {
      permissions: [PermissionsEnum.LOGIN, PermissionsEnum.CONFIGMANAGER]
    }
  }
];
